export default __webpack_public_path__ + "static/media/warning--pedestrians-crossing--g8.04317383.png";